"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _classcat = _interopRequireDefault(require("classcat"));

var _Modal = _interopRequireDefault(require("./Modal"));

var _SVGIcon = _interopRequireDefault(require("./SVGIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const width = 256;

const Icon = _styledComponents.default.div.withConfig({
  displayName: "Menu__Icon",
  componentId: "wiq2ar-0"
})(["position:relative;", ";&:hover{background:#f2f2f2;}", "{svg path{fill:#888;}}"], p => p.theme.transition, _SVGIcon.default);

const Items = _styledComponents.default.ul.withConfig({
  displayName: "Menu__Items",
  componentId: "wiq2ar-1"
})(["background:#fff;position:absolute;right:0;top:0;z-index:2;width:", "px;padding:8px 0;", ";"], width, p => p.itemsStyle);

const Item = _styledComponents.default.li.withConfig({
  displayName: "Menu__Item",
  componentId: "wiq2ar-2"
})(["", ";cursor:pointer;display:flex;align-items:center;", " ", " &:hover{background:#f2f2f2;}"], p => p.theme.transition, p => p.size === 'small' && (0, _styledComponents.css)(["padding:0 16px;height:32px;"]), p => p.size === 'large' && (0, _styledComponents.css)(["padding:0 24px;height:48px;"]));

const Separator = _styledComponents.default.div.withConfig({
  displayName: "Menu__Separator",
  componentId: "wiq2ar-3"
})(["border-bottom:1px solid #dfdfdf;margin:8px 0;"]);

class Menu extends _react.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      show: false,
      top: 0,
      left: 0
    });

    _defineProperty(this, "calculatePos", () => {
      const rect = this.iconRef.getBoundingClientRect();
      this.setState({
        top: rect.top - 4,
        left: rect.right - width
      });
    });

    _defineProperty(this, "setIconRef", el => {
      this.iconRef = el;
    });

    _defineProperty(this, "showItems", () => {
      this.setState({
        show: true
      });
    });

    _defineProperty(this, "hideItems", () => {
      this.setState({
        show: false
      });
    });

    _defineProperty(this, "handleItemSelect", action => () => {
      const {
        onSelect
      } = this.props;
      this.hideItems();
      onSelect(action);
    });
  }

  componentDidMount() {
    window.addEventListener('resize', this.calculatePos);
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevState.show && this.state.show) {
      this.calculatePos();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.calculatePos);
  }

  render() {
    const {
      className,
      items,
      icon,
      size = 'large',
      itemsStyle
    } = this.props;
    const {
      show,
      top,
      left
    } = this.state;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: className
    }, /*#__PURE__*/_react.default.createElement(Icon, {
      className: (0, _classcat.default)({
        'menu-icon': true,
        active: show
      }),
      ref: this.setIconRef,
      onClick: this.showItems
    }, /*#__PURE__*/_react.default.createElement(_SVGIcon.default, {
      name: icon || 'dotsVertical'
    })), /*#__PURE__*/_react.default.createElement(_Modal.default, {
      show: show,
      width: width,
      delta: "10",
      top: top,
      left: left,
      attachToBody: true,
      onClose: this.hideItems
    }, /*#__PURE__*/_react.default.createElement(Items, {
      className: "menu-items",
      itemsStyle: itemsStyle
    }, items.map((item, idx) => {
      if (item.text === '-') {
        return /*#__PURE__*/_react.default.createElement(Separator, {
          key: idx
        });
      }

      return /*#__PURE__*/_react.default.createElement(Item, {
        size: size,
        key: idx,
        onClick: this.handleItemSelect(item.action)
      }, item.text);
    }))));
  }

}

var _default = (0, _styledComponents.default)(Menu).withConfig({
  displayName: "Menu",
  componentId: "wiq2ar-4"
})(["position:relative;"]);

exports.default = _default;